// extracted by mini-css-extract-plugin
export default {"text-area-label":"TextArea_component_text-area-label__szD3Z","text-area-label-pwa-pnnv":"TextArea_component_text-area-label-pwa-pnnv__9NApB"};